import { render, staticRenderFns } from "./WarningText.vue?vue&type=template&id=673ed9c0&scoped=true"
import script from "./WarningText.vue?vue&type=script&lang=js"
export * from "./WarningText.vue?vue&type=script&lang=js"
import style0 from "./WarningText.vue?vue&type=style&index=0&id=673ed9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ed9c0",
  null
  
)

export default component.exports